import React from 'react'

import News from '../../molecules/News'

const NewsList = ({ news }) => (
  news.map((item) => (
    <News
      key={ item.id }
      news={ item }
    />
  ))
)

export default NewsList



// WEBPACK FOOTER //
// ./src/components/organisms/NewsList/NewsList.js